var _a;
import { COMPONENT_NAME_PREFIX } from '../../constants';
var elementName = COMPONENT_NAME_PREFIX + "stepper";
var classes = {
    STEPPER: 'tyl-stepper',
    LINEAR: 'tyl-stepper--linear',
    ALTERNATIVE: 'tyl-stepper--alternative',
    CLUSTERED: 'tyl-stepper--clustered',
    FIXED: 'tyl-stepper--fixed',
    ALIGN_LEFT: 'tyl-stepper--align-left',
    ALIGN_CENTER: 'tyl-stepper--align-center',
    ALIGN_RIGHT: 'tyl-stepper--align-right',
    VERTICAL: 'tyl-stepper--vertical',
    FOCUSED: 'tyl-stepper--focused',
};
var selectors = {
    STEPPER: "." + classes.STEPPER
};
var attributes = {
    SELECTED_INDEX: 'selected-index',
    LINEAR: 'linear',
    ALTERNATIVE: 'alternative',
    LAYOUT_MODE: 'layout-mode',
    LAYOUT_ALIGN: 'layout-align',
    DISABLED: 'disabled',
    VERTICAL: 'vertical',
};
var strings = {
    ARROW_LEFT_KEY: 'ArrowLeft',
    ARROW_RIGHT_KEY: 'ArrowRight',
    ARROW_UP_KEY: 'ArrowUp',
    ARROW_DOWN_KEY: 'ArrowDown',
    END_KEY: 'End',
    ENTER_KEY: 'Enter',
    HOME_KEY: 'Home',
    SPACE_KEY: 'Space',
    TAB_KEY: 'Tab',
};
var numbers = {
    ARROW_LEFT_KEYCODE: 37,
    ARROW_RIGHT_KEYCODE: 39,
    END_KEYCODE: 35,
    HOME_KEYCODE: 36,
    ENTER_KEYCODE: 13,
    SPACE_KEYCODE: 32
};
var ACCEPTABLE_KEYS = [
    strings.ARROW_LEFT_KEY,
    strings.ARROW_RIGHT_KEY,
    strings.ARROW_DOWN_KEY,
    strings.ARROW_UP_KEY,
    strings.END_KEY,
    strings.HOME_KEY,
    strings.ENTER_KEY,
    strings.SPACE_KEY,
    strings.TAB_KEY
];
var KEYCODE_MAP = (_a = {},
    _a[numbers.ARROW_LEFT_KEYCODE] = strings.ARROW_LEFT_KEY,
    _a[numbers.ARROW_RIGHT_KEYCODE] = strings.ARROW_RIGHT_KEY,
    _a[numbers.END_KEYCODE] = strings.END_KEY,
    _a[numbers.HOME_KEYCODE] = strings.HOME_KEY,
    _a[numbers.ENTER_KEYCODE] = strings.ENTER_KEY,
    _a[numbers.SPACE_KEYCODE] = strings.SPACE_KEY,
    _a);
export var STEPPER_CONSTANTS = {
    elementName: elementName,
    classes: classes,
    selectors: selectors,
    attributes: attributes,
    numbers: numbers,
    strings: strings,
    ACCEPTABLE_KEYS: ACCEPTABLE_KEYS,
    KEYCODE_MAP: KEYCODE_MAP
};
